import { render, staticRenderFns } from "./mileageSta.vue?vue&type=template&id=05c1d12c&scoped=true"
import script from "./mileageSta.vue?vue&type=script&lang=js"
export * from "./mileageSta.vue?vue&type=script&lang=js"
import style0 from "./mileageSta.vue?vue&type=style&index=0&id=05c1d12c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c1d12c",
  null
  
)

export default component.exports